import { leadAssignmentRulesApi } from 'app/services/api';
import _ from 'lodash';

import { catchAsyncActionError } from 'utils/action';
import { jsonParse } from 'utils/json';
import { logger } from 'utils/logger';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LEAD_POOL_CRITERIA_SCHEMA_ACTION_TYPE = createNamedActions('leadPoolCriteriaSchema', {
  GET_SCHEMA: 'GET_SCHEMA',
});

// The Loans candidate-user definition is delivered as a serialized JSON string body (unlike the
// CRM leadMatch endpoint, which returns a parsed object). ExpressionField expects an object, so
// parse a string payload before storing it. A malformed/truncated body is logged and degrades to
// an empty schema rather than throwing into the swallowed Promise.all (which would leave the
// pool-criteria builder silently empty with no trace).
const parseSchema = data => {
  if (!_.isString(data)) {
    return data;
  }

  try {
    return jsonParse(data);
  } catch (err) {
    logger.error('Failed to parse lead pool-criteria expression schema', err);

    return {};
  }
};

export const getLeadPoolCriteriaSchemaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await leadAssignmentRulesApi.getLeadPoolCriteriaExpressionDefinition();

  return dispatch({
    type: LEAD_POOL_CRITERIA_SCHEMA_ACTION_TYPE.GET_SCHEMA,
    payload: parseSchema(data),
  });
});
